module.exports = __webpack_public_path__ + "static/media/dadAndBaby.f6dca8a8.jpeg";